<template>
    <div class="article-detail">
        <div class="banner">
            <div class="title">最新文章</div>
        </div>

        <div class="article-detail-wrap container">
            <div class="breadcrumbs">
                <router-link :to="{ name: 'article'}">
                    <label class="clickable">最新文章</label>
                </router-link>
                <img src="@/assets/img/landingPage/arrow_right.svg"/>
                <label>文章詳情</label>
            </div>
            <div class="title">
                <div>{{article.title}}</div>
            </div>
            <div class="tags-list">
                <div class="tag" v-for="(tag, index) in article.tags" :key="index">{{tag}}</div>
            </div>
            <div class="cover" v-bind:style="{backgroundImage:'url(' + article.cover + ')'}"></div>
            <div class="content">
                <div class="paragraph" v-for="(paragraph, index) in article.content" :key="index">{{paragraph}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted () {
        this.$analytics.logEvent("文章內頁", {
            screen_name: "文章內頁"
        });
    },
    components: {

    },
    data () {
        return {
            article: {
              cover: 'https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article_5.jpeg',
              title: '全台租金10年不減，租屋族的未來在哪裡',
              tags: ['租屋', '租金', '房價', '租屋需求', '買房'],
              content: ['現代年輕人，只要談到買房，總會出現心有餘而力不足的無奈，這居高不下的房價，讓多少年輕人寧願當個租屋族也不願犧牲生活品質買房，但談到租金，近年來也一直沒有下滑的的趨勢，每個月大筆大筆的租金繳出去，也得不到心中的踏實感，年輕人不禁心中自問，到底未來在哪裡？','根據主計總處公布每月租金報告顯示，國內租金自民國100年3月後，至去年底為止，只有在103年11月、12月是持平，其他都是每月上漲。雖在2020年初新冠疫情爆發後，聽到許多房東打出降低房租優惠要與租屋族們一起共體時艱，但從10年統計數據看起來，租金仍沒有下滑，對年輕人來說真的是很絕望，多少年輕人出外打拼為的就是要飛黃騰打，但現實就是高房價讓有錢人繼續買房，租屋族只能繼續租房。','租金不減的情況下，大部分外出打拼租屋族選擇房屋時，仍希望能在合理租金範圍內維持著好的生活水平，為的就是一個家的感覺，因此對於租屋條件也開始會下修，例如：即使繁華的大台北區域找到價格較低的套房或雅房，但那家徒四壁的小坪數只會讓租屋族更沮喪，因此寧可每天多花些通勤時間，選擇居住於相同低廉租金但坪數大一點的新北蛋白區。可是漸漸地又可以發現蛋白區的租金需求增加，價格競爭下，租金也悄悄漲了起來，租屋族就只能在下修租屋條件，繼續在這種低壓的惡性循環中求生存。','多少年輕人希望政府能協助，看得出政府這些年也一直在推出各種租屋條款，為的就是要協助無殼蝸牛族群，但或許真正的原因不是規範房東或者租屋津貼補助，若政府可以分散各縣市的就業機會，讓租屋需求不要那麼的集中，降低租金價格的競爭，就可以維持合理的租金價格，於此同時，也可以減少有錢人繼續炒房的機會，慢慢的把房市裡低氣壓的惡性循環帶往更好的發展。']
            }
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
    .article-detail {
        margin-bottom: 40px;
        .banner {
            display: none;
        }
        .container {
            width: 911px;
            margin-left: auto;
            margin-right: auto;
            box-sizing: border-box;
        }
        .article-detail-wrap {
            .breadcrumbs {
                margin-top: 40px;
                label.clickable {
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #b1b0b0;
                    cursor: pointer;
                }
                label.clickable:hover {
                    color: #7d7979;
                }
                label{
                    font-size: 16px;
                    font-weight: 500;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #474342;
                    cursor: unset;
                }
                img {
                    margin-left: 12px;
                    margin-right: 12px;
                }
            }
            .title {
                margin-top: 34px;
                margin-bottom: 28px;
                div {
                    font-size: 26px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #353535;
                }
            }
            .tags-list {
                margin-bottom: 20px;
                .tag {
                    display: inline-block;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #838282;
                    padding: 6px 14px;
                    border-radius: 5px;
                    background-color: #f1f3f6;
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
            }
            .cover {
                height: 400px;
                width: auto;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
            }
            .content {
                margin-top: 40px;
                .paragraph {
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #353535;
                    margin-bottom: 32px;
                }
            }
        }
    }
    @media screen and (max-width: 1100px){
        .article-detail {
            .banner {
                display: block;
                position: relative;
                margin-bottom: 14px;
                height: 198px;
                width: 100%;
                background-image: url('https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;

                .title {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 24px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #ffffff;
                }
            }
            .container {
                width: unset;
                padding: 0 20px;
            }
            .article-detail-wrap {
                .breadcrumbs {
                    display: none;
                }
                .cover {
                    height: 207px;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/officailPage/article/articleDetail_5.vue